module.exports = __webpack_public_path__ + "img/swift-bostergreen-gls-plata-silice.90cb5c83.png";